var map = {
	"./1.png": 9841,
	"./2.png": 2410,
	"./3.png": 4323,
	"./4.png": 6924,
	"./erupt1.gif": 6134,
	"./erupt2.gif": 8849,
	"./erupt3.gif": 2840,
	"./erupt4.gif": 9491,
	"./gb-t.png": 8682,
	"./gb.png": 6869,
	"./gt-t.png": 9176,
	"./gt.png": 4403,
	"./here.png": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4944;